import { useInvalidateAccountSettingsQuery } from '@/entities/account';
import { useInvalidateProfileQuery } from '@/entities/profile';
import {
  IUpdateAccountSettingsRequestDto,
  patchAuthSettings,
} from '@/shared/api/auth';
import { useAppMutation } from '@/shared/lib/useAppMutation';
import { useNotifications } from '@/shared/ui/Notifications';

export function useUpdateAccountSettings() {
  const invalidateAccountSettings = useInvalidateAccountSettingsQuery();
  const invalidateProfile = useInvalidateProfileQuery();
  const { addNotification } = useNotifications();

  const updateAccountSettingsMutation = useAppMutation({
    mutationFn: (vars: IUpdateAccountSettingsRequestDto) =>
      patchAuthSettings(vars),
    onSettled: async () => {
      await Promise.all([invalidateAccountSettings(), invalidateProfile()]);
    },
    onError: (error) => {
      addNotification({
        type: 'error',
        title: error.message,
        caption: error.data?.details,
      });
    },
  });

  const updateAccountSettings = async (
    {
      timezone,
      locale,
      twofa_is_active,
      phone,
      current_password,
    }: IUpdateAccountSettingsRequestDto,
    onChanged?: () => void
  ) => {
    updateAccountSettingsMutation.mutate(
      {
        timezone,
        locale,
        twofa_is_active,
        phone: phone?.replace(/[^\d+]/g, ''),
        current_password,
      },
      {
        onSuccess: onChanged,
      }
    );
  };

  return {
    updateAccountSettings,
    ...updateAccountSettingsMutation,
  };
}
